import { Fragment } from 'react';

import { implicationParts } from '../engine/implications';
import { type ICancellationImpact } from '../types';

interface IImplicationsLine {
	impact: ICancellationImpact | undefined;
	expectedVotes: number | null | undefined;
	compact?: boolean;
}

/** The signature line on every alert: what this cancellation costs the campaign. */
const ImplicationsLine = ({ impact, expectedVotes, compact = false }: IImplicationsLine) => {
	const parts = implicationParts(impact, expectedVotes);
	return (
		<p className={`pc-implications${compact ? ' pc-implications--compact' : ''}`}>
			{parts.map((part, i) => (
				<Fragment key={part.key}>
					{i > 0 ? (
						<span
							className='pc-implications__sep'
							aria-hidden='true'
						>
							·
						</span>
					) : null}
					<span className={`pc-implications__part pc-implications__part--${part.tone}`}>{part.text}</span>
				</Fragment>
			))}
		</p>
	);
};

export default ImplicationsLine;
